<template>
  <div>
    <!-- 第三方仓库地址 -->
    <el-dialog :title="$t('message.thirdPartyWarehouseAddress')" :close-on-click-modal="false"
      :visible.sync="dialogVisible" width="1200px" center>
      <div class="content">
        <div class="row">
          <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
            <el-tab-pane :label="item.group_name" :name="item.group_name" v-for="(item, index) in tableData"
              :key="index"></el-tab-pane>
          </el-tabs>
          <!-- 搜索 -->
          <div class="search">
            <el-input v-model="val" placeholder="搜索" size="small" clearable @clear="search"></el-input>
            <el-button type="primary" size="small" style="margin-left: 10px;" @click="search">搜索</el-button>
          </div>
        </div>
        <div class="list">
          <div class="table">
            <ol>
              <!-- 仓库编号 -->
              <li>
                仓库编号
              </li>
              <!-- 仓库名 -->
              <li>
                仓库名
              </li>
              <!-- 地址 -->
              <li class="flex15">
                地址
              </li>
              <!-- 邮编 -->
              <li>
                邮编
              </li>
              <!-- 携帯番号 -->
              <li>
                携帯番号
              </li>
              <!-- 操作 -->
              <li>
                操作
              </li>
            </ol>
            <ul v-for="(item, index) in result" :key="index">
              <!-- 仓库编号 -->
              <li>
                {{ item.sn }}
              </li>
              <!-- 仓库名 -->
              <li>
                {{ item.name }}
              </li>
              <!-- 地址 -->
              <li class="flex15">
                {{ item.address_jpn }}
              </li>
              <!-- 邮编 -->
              <li>
                {{ item.zip }}
              </li>
              <!-- 携帯番号 -->
              <li>
                {{ item.mobile }}
              </li>
              <!-- 操作 -->
              <li>
                <el-button type="primary" @click="save(item)">
                  选择
                </el-button>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <!--取 消  -->
        <el-button @click="dialogVisible = false">{{
          $t("message.cancel")
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      tableData: [],
      result: [],
      dialogVisible: false,
      activeName: '亚马逊仓库',
      val: '',
      resultAll: []
    };
  },
  created() {
    this.$api.clienteleApi.third_party().then(res => {
      this.tableData = res.data
      this.handleClick()
    })
  },
  methods: {
    handleClick() {
      this.resultAll = this.tableData.find(item => item.group_name == this.activeName).result
      this.search()
    },
    // 搜索
    search() {
      if (this.val) {
        this.result = this.resultAll.filter(item => item.sn == this.val)
      } else {
        this.result = JSON.parse(JSON.stringify(this.resultAll))
      }

    },
    // 保存
    save(item) {
      this.$parent.addAddressSuccess(item)
      this.dialogVisible = false

    },

  },
};
</script>
<style lang='scss' scoped>
.content {
  margin: 0px 15px;

  .row {
    position: relative;

    .search {
      display: flex;
      position: absolute;
      top: 2px;
      left: 650px
    }
  }

  .list {
    max-height: 600px;
    overflow-y: auto;
  }

  .table {
    border: 1px solid #edeff4;

    ol {
      display: flex;
      position: sticky;
      top: 0;
      left: 0
    }

    ul {
      display: flex;
      padding: 0;


      li {
        padding: 15px;
      }
    }

    li {
      border-right: 1px solid #edeff4;

      &:nth-last-child(1) {
        border: 0;
      }
    }

    .flex15 {
      flex: 1.5;
    }
  }

  /deep/.el-input {
    width: 60%;
  }

  /deep/.el-select {
    .el-input {
      width: 100%;
    }

    width: 80%;
  }
}
</style>